import React from "react";
import PolicyPageTemplate from "../../components/common/PolicyPageTemplate";
import { HeartHandshake } from "lucide-react";

const SECTIONS = [
  {
    number: "1",
    title: "Zero Tolerance Policy",
    body: "AAFSA maintains a strict zero-tolerance approach toward any form of child abuse, neglect, exploitation, violence, or discrimination. The safety, wellbeing, and dignity of children and vulnerable youth are the supreme priority across all our initiatives, projects, and engagements.",
  },
  {
    number: "2",
    title: "Scope & Applicability",
    body: "This Child Safety Policy applies to all AAFSA staff, board members, volunteers, interns, contractors, partner organisations, donors, and field visitors. Everyone acting on behalf of or associated with AAFSA is bound to uphold these safeguarding commitments without exception.",
  },
  {
    number: "3",
    title: "Code of Conduct with Children",
    body: "All representatives must treat every child with compassion, fairness, and respect. Personnel are strictly prohibited from engaging in physical punishment, derogatory language, emotional abuse, or unmonitored one-on-one contact with a child. Clear professional and emotional boundaries must be maintained at all times.",
  },
  {
    number: "4",
    title: "Photography, Media & Privacy",
    body: "We preserve the dignity and privacy of every child depicted in our campaigns. Media capturing children may only be taken with informed, written consent from parents or legal guardians. We never publish full names, home locations, sensitive medical details, or compromising imagery that could put a child at risk.",
  },
  {
    number: "5",
    title: "Digital Safety & Online Engagements",
    body: "Unsupervised direct electronic communication between donors/volunteers and beneficiary children is strictly forbidden. All online educational sessions, mentorship interactions, and communications must take place through authorized, recorded, and monitored organizational platforms.",
  },
  {
    number: "6",
    title: "Recruitment & Screening",
    body: "To protect children in our care, all prospective employees, interns, and field volunteers undergoing placement with child-centric programs are subjected to thorough identity verification, criminal background clearances, and reference cross-checks before deployment.",
  },
  {
    number: "7",
    title: "Mandatory Reporting & Whistleblowing",
    body: "Anyone who observes, suspects, or receives an allegation of child abuse or safeguarding breaches must report it immediately (within 24 hours). AAFSA provides secure, anonymous reporting channels and ensures comprehensive whistleblower protection against retaliation.",
  },
  {
    number: "8",
    title: "Incident Response & Law Enforcement",
    body: "All reported safeguarding incidents are immediately escalated to our Safeguarding Committee. In cases involving potential criminal harm or severe misconduct, AAFSA promptly reports the matter to local law enforcement and child welfare authorities while ensuring trauma-informed support for the child.",
  },
  {
    number: "9",
    title: "Safeguarding Education & Capacity Building",
    body: "We conduct regular child rights workshops, safeguarding refresher courses, and risk assessment reviews for all team members and community partners to reinforce preventive practices and vigilance across all field environments.",
  },
  {
    number: "10",
    title: "Safeguarding Officer Contact",
    body: "If you have any questions, concerns, or wish to report a child safety issue, please contact our Designated Safeguarding Officer at safeguarding@aafsa.org. All disclosures are handled with utmost urgency, impartiality, and confidentiality.",
  },
];

const ChildSafetyPolicy = () => {
  return (
    <PolicyPageTemplate
      title="Child Safety Policy"
      subtitle="Protecting the rights, dignity, and wellbeing of every child we serve through zero-tolerance policies and comprehensive safeguarding."
      dateLabel="LAST UPDATED"
      dateValue="1 January 2025"
      contactEmail="safeguarding@aafsa.org"
      contactRole="Designated Safeguarding Officer"
      intro="AAFSA is passionately dedicated to protecting the rights, dignity, and wellbeing of every child we serve. We create safe and nurturing environments where children can learn, grow, and thrive free from violence, exploitation, and harm."
      sections={SECTIONS}
      policyIcon={HeartHandshake}
    />
  );
};

export default ChildSafetyPolicy;
